<template>
  <Drawer title="新增团队" v-model="visible" width="520" class="my-drawer" :mask-closable="false">
    <Form ref="form" :model="formData" :label-width="100" class="page-form less">
      <FormItem prop="name" label="团队名称" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.name" placeholder="请输入" maxlength="16"/>
      </FormItem>
      <FormItem prop="code" label="内部组织编码" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.code" placeholder="请输入"/>
      </FormItem>
      <FormItem label="所属机构">
        <Input :value="!curOrg.orgType?detailData.organizationName:curOrg.name" disabled placeholder="请输入"/>
      </FormItem>
      <FormItem label="上级团队" v-if="!curOrg.orgType" key="parentName">
        <Input :value="detailData.name" disabled placeholder="请输入"/>
      </FormItem>
      <FormItem prop="contacts" label="联系人">
        <Input v-model="formData.contacts" placeholder="请输入"/>
      </FormItem>
      <FormItem prop="mobile" label="联系电话" :rules="$units.formRule.tel('请输入正确的手机号', false)">
        <Input v-model="formData.mobile" placeholder="请输入"/>
      </FormItem>
      <FormItem prop="sortNum" label="排序">
        <template slot="label">
          排序
          <Tooltip content="数字越大，顺序越靠前" placement="top">
            <Icon type="md-help-circle" style="color:#A8ADB7" />
          </Tooltip>
        </template>
        <Input v-model="formData.sortNum" placeholder="请输入"/>
      </FormItem>
      <FormItem label="所在省市" class="full">
        <Select v-model="formData.province" placeholder="省" @on-change="provinceChange" filterable style="width:180px">
          <Option v-for="(item,i) in regionsArr" :value="item.name" :key="i">{{ item.name }}</Option>
        </Select>
        <Select v-model="formData.city" placeholder="市" filterable style="width:180px;margin-left:22px">
          <Option v-for="(item,i) in cityList" :value="item.name" :key="i">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <FormItem prop="templateId" label="服务费模板" class="full">
        <Select v-model="formData.templateId" placeholder="请选择" filterable style="width:300px">
          <Option v-for="(item,i) in templateList" :value="item.id" :key="i">{{ item.name }}</Option>
        </Select>
        <span class="text-btn" @click="openTemplateEdit()" v-if="$units.pointAction('org_1_5')">创建模板</span>
      </FormItem>
      <FormItem prop="remark" label="备注" class="full">
        <Input v-model="formData.remark" type="textarea" placeholder="最多不超过50个字" maxlength="50" :autosize="{ minRows: 3}" show-word-limit/>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible=false">取消</Button>
      <Button type="primary" @click="save" :loading="loading">确认</Button>
    </div>

    <!-- 新增模板 -->
    <edit-template ref="editTemplate" v-if="visible" @success="getTemplate"></edit-template>
  </Drawer>
</template>

<script>
import editTemplate from "@/components/commons/feeTemplate/editTemplate";
export default {
  components: {editTemplate},
  props: {},
  data() {
    return {
      visible:false,
      loading:false,
      formData:{},
      curOrg:{},//当前的节点数据
      detailData:{},//详情数据
      regionsArr:[],//区域数据
      cityList:[],//市级数据
      templateList:[],//模板列表
      icoData:[]
    };
  },
  watch: {},
  computed: {
  },
  created() {},
  mounted() {
    
  },
  methods: {
    save(){
      this.$refs.form.validate().then(isok=>{
        if(!isok){
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        if(this.curOrg.orgType){//父级是机构
          formData.levelCode = '20001';
          formData.parentId = '0';
          formData.organizationId = this.curOrg.id;
        }else{//父级是团队
          formData.levelCode = this.curOrg.levelCode*1+1;
          formData.parentId = this.curOrg.id;
          formData.organizationId = this.detailData.organizationId;
        }
        if(this.loading){
          return;
        }
        this.loading = true;
        this.$http({
          type: "POST",
          url: "/buz/organizationGroup/add",
          data: formData,
          apiPermissionCode:'org_1_3'
        }).then(res => {
          this.$notice.success("提交成功");
          this.visible = false;
          this.$emit("success",res.data.id);
          localStorage.setItem('updataOrgAndTeam', 1);
        }).finally(res => {
          this.loading = false;
        });
      })
    },
    open(orgData,detailData){
      this.visible = true;
      this.curOrg = orgData;
      this.detailData = detailData;
      this.icoData = [];
      this.$refs.form&&this.$refs.form.resetFields();
      this.formData = {
        status:'1'
      }
      this.getRegion();// 获取省市区域数据
      this.getTemplate();//模板列表
    },
    //模板列表
    getTemplate(){
      this.$http({
        url: "/buz/template/getOrgTemplateList",
        type: "GET",
        data: {
          orgId:!this.curOrg.orgType?this.detailData.organizationId:this.curOrg.id,
          templateType:2,
        },
      }).then((res) => {
        this.templateList = res.data;
      });
    },
    // 获取省市区域数据
    async getRegion() {
      this.regionsArr = await this.$store.dispatch("getRegion");
    },
    // 选择省
    provinceChange(name){
      this.$set(this.formData, "city", "")
      const data = this.regionsArr.find(item=>{
        return item.name == name;
      })
      this.cityList = data.children;
    },
    // 上传图片
    uploadImg(data){
      console.log(data)
      data = data[0];
      if(data.h!=data.w){
        this.$notice.msg("请上传正方形图片")
        this.icoData = [];
      }else{
        this.$set(this.formData,"ico",data.path);
      }
    },
    openTemplateEdit(){
      this.$refs.editTemplate.open(
        {
          type: "2",
          orgId: !this.curOrg.orgType?this.detailData.organizationId:this.curOrg.id,
          orgName: !this.curOrg.orgType?this.detailData.organizationName:this.curOrg.name
        },
        true
      );
    }
  },
};
</script>
<style lang="scss" scoped>
.my-drawer /deep/ {
  .text-btn {
    font-size: 12px;
    color: #236DFF;
    cursor: pointer;
    margin-left: 10px;
    &:active {
      opacity: 0.7;
    }
  }
  .ivu-radio-wrapper {
    font-size: 12px;
  }
  .upload-box {
    display: inline-block;
    vertical-align: bottom;
    .demo-upload-list img,
    .demo-upload-list,
    .uploadBoxs {
      width: 80px !important;
      height: 80px;
      vertical-align: top;
      margin: 0;
    }
  }
  .upload-info {
    display: inline-block;
    color: #A8ADB7;
    font-size: 12px;
    vertical-align: bottom;
    line-height: 1;
    margin-left: 10px;
  }
}
</style>